import { getImg } from "../../utils";
import "./EmptyBlock.scss";

export const EmptyBlockVertical = ({ emptyState, title, description }) => {
  return (
    <>
      <div className="empty-block-container-vertical">
        <div className="image">{getImg(emptyState)}</div>
        <div className="description">
          <div className="page title">{title}</div>
          <div className="page subtitle">{description}</div>
        </div>
      </div>
    </>
  );
};

export const EmptyBlock = ({
  emptyState,
  title,
  description,
  children,
  isError = false,
  isBlock = false,
}) => {
  const titleClass = `title${isError ? " error" : " page"}`;
  const subtitleClass = `subtitle${isError ? " error" : " page"}`;

  const Description = () => {
    return (
      <div className="description">
        <div className={titleClass}>{title}</div>
        <div className={subtitleClass}>{description}</div>
        {children}
      </div>
    );
  };

  return (
    <div className="empty-block-container">
      {isBlock ? <Description /> : null}
      <div className="image">{getImg(emptyState)}</div>
      {!isBlock ? <Description /> : null}
    </div>
  );
};
